(function (once, Drupal) {
  Drupal.behaviors.shareBehavior = {
    attach: function (context, settings) {
      once('jumpbehaviour', '.jump-menu--responsive-button', context).forEach(
        function (element) {
          element.addEventListener('click', function () {
            element.parentElement.classList.toggle('active');
          });

          element.parentElement
            .querySelectorAll('ul > li > a')
            .forEach(function (link) {
              link.addEventListener('click', () =>
                element.parentElement.classList.remove('active')
              );
            });
        }
      );
    },
  };
})(once, Drupal);
